import React from 'react';
import { SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="border-t-2 border-volt/25 bg-carbon" data-id="element-76" data-mp="3gezev8fo7z39">
      <div className="mx-auto max-w-3xl px-3 py-7 text-center sm:px-6" data-id="element-77" data-mp="3ghc3u5juj9pt">
        <p className="text-[0.72rem] font-extrabold uppercase tracking-[0.12em] text-volt sm:text-xs" data-id="element-78" data-mp="32p5m4f11ouo9">
          © 2026 — Todos los Derechos Reservados.
        </p>
        <p className="mt-3 text-[0.68rem] leading-snug text-steel-dark sm:text-[0.72rem]" data-id="element-79" data-mp="3ueijvsd6qubc">
          Sistema Electricista Domiciliario Desde Cero™ es un producto
          educativo. No sustituye formación profesional, práctica supervisada,
          normativa eléctrica, licencias, certificaciones, permisos ni el
          criterio de un profesional habilitado. La electricidad puede causar
          lesiones graves, electrocución, quemaduras o incendios.
        </p>
        <p className="mt-3 text-[0.72rem] text-steel sm:text-xs" data-id="element-80" data-mp="2a1jm1gr10865">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-volt underline underline-offset-2" data-id="element-81" data-mp="2ew71kq41xs8l">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <p className="mt-2 text-[0.7rem] text-steel-dark sm:text-xs" data-id="element-82" data-mp="3gck0v58qyqnr">
          Términos y Condiciones • Política de Privacidad • Contacto
        </p>
      </div>
    </footer>;
}